import { GridColDef } from '@mui/x-data-grid';
import React from 'react';

import DataGrid from '#app/Component/DataGrid';
import Guest from '#app/Component/Guest';
import IconAction from '#app/Component/IconAction';
import { getRoutePathname } from '#app/Handler/RouteHandler';
import { transformObjectToDataGridRowsArray } from '#app/Util/DataGridDataTransformer';
import { momentDateFormatter } from '#app/Util/MomentDateFormatter';
import useOrderClientList from '#app/View/Shop/Sale/ShopSalesList/hooks/useOrderClientList';
import { OrderClientList, OrderClientState, OrderClientStateTranslation } from '#app/typings/orderClient';

type Props = Omit<ReturnType<typeof useOrderClientList>, 'setFilters'>;

const List: React.FC<Props> = ({ clients, totalItems, loading, pagination, sorting, setPagination, setSorting }) => {
  const columns: GridColDef[] = [
    {
      field: 'number',
      headerName: 'Référence',
      minWidth: 150,
      sortable: false,
    },
    {
      field: 'clientEmail',
      headerName: 'Email',
      valueGetter: (_, row: OrderClientList) => row.client?.email,
      flex: 1,
      sortable: false,
    },
    {
      field: 'clientName',
      headerName: 'Client',
      valueGetter: (_, row: OrderClientList) => row.client?.name,
      flex: 1,
      sortable: false,
    },
    {
      field: 'orderClientState',
      headerName: 'Etat',
      valueGetter: (value: OrderClientState) => OrderClientStateTranslation[value],
    },
    {
      field: 'createdAt',
      headerName: 'Date de création',
      valueGetter: (value: string) => momentDateFormatter.dateTimeToFormatFr(value),
      minWidth: 130,
    },
    {
      field: 'isGuest',
      headerName: 'Guest',
      renderCell: ({ value }) => <Guest isGuest={value} />,
      sortable: false,
    },
    {
      field: 'action',
      headerName: 'Action',
      type: 'actions',
      getActions: ({ row }) => [
        <IconAction
          title="Visualiser"
          icon="view"
          to={getRoutePathname('shop_seller_order_client', { uuid: row.uuid })}
        />,
      ],
    },
  ];

  return (
    <DataGrid
      rows={transformObjectToDataGridRowsArray<OrderClientList>(clients)}
      columns={columns}
      loading={loading}
      rowCount={totalItems}
      setSorting={setSorting}
      setPagination={setPagination}
      pagination={pagination}
      sorting={sorting}
    />
  );
};

export default List;
